import * as ClientConfig from "../config/ClientConfig.js";
import * as StorageService from "../services/StorageService.js";
import * as RestClient from "../util/api/restClient"
import { getAppLanguage } from "../util/common.js";
import {LOCALSTORAGE_ITEMS} from "../util/Constants";

const getAllCampaigns =  async (shopName) => {
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/shop/"+shopName+"/feeds?lang="+getAppLanguage();
        const response = fetch(finalURL, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-Zoniz-Token": StorageService.getItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN),
                "X-Zoniz-User-Email": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            },
        });
        return response;
    });
}

const getCampaignDetails =  async (shopName, promotionName) => {
    return RestClient.handleResponse(() => {
        const finalURL = ClientConfig.URL_RESOURCE_SERVER + "/api/feed/"+shopName+"/"+promotionName+"?lang="+getAppLanguage();
        const response = fetch(finalURL, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-Zoniz-Token": StorageService.getItem(LOCALSTORAGE_ITEMS.ACCESS_TOKEN),
                "X-Zoniz-User-Email": StorageService.getItem(LOCALSTORAGE_ITEMS.USER_EMAIL),
            },
        });
        return response;
    });
}




export {
    getAllCampaigns,
    getCampaignDetails
}